/* TLY direction-aware gold fill (Claude, 2026-10-23, Steven's tly-tiles-direction-fill mockup; standing rule for every gold frame).
   Binds every .tly-goldfill element (delegated, so cards added later work too). Mouse/pen only - touch is ignored.
   Enter: gold pours in from the nearest edge; leave: gold drains toward the exit edge. Adds/removes .is-on, which carries the lift,
   shadow and photo zoom. Keyboard focus is handled by CSS (:focus-visible, plain left-to-right). Reduced motion: CSS removes the
   transitions, so the frame simply shows/hides. Loaded once site-wide from layout/theme.liquid. */
(function () {
  if (window.tlyGoldfill) return;
  window.tlyGoldfill = true;
  document.documentElement.classList.add('tly-goldfill-js');

  var POS = { left: 'left center', right: 'right center', top: 'center top', bottom: 'center bottom' };
  function emptySize(edge) { return (edge === 'left' || edge === 'right') ? '0% 100%' : '100% 0%'; }

  function edgeOf(el, e) {
    var r = el.getBoundingClientRect();
    var x = e.clientX - r.left, y = e.clientY - r.top;
    if (x < 0) return 'left';
    if (x > r.width) return 'right';
    if (y < 0) return 'top';
    if (y > r.height) return 'bottom';
    var d = { left: x, right: r.width - x, top: y, bottom: r.height - y }, best = 'left';
    for (var k in d) if (d[k] < d[best]) best = k;
    return best;
  }

  function setNow(el, pos, size) {
    el.style.transition = 'none';
    el.style.backgroundPosition = pos;
    if (size) el.style.backgroundSize = size;
    void el.offsetWidth;
    el.style.transition = '';
  }

  function enter(el, e) {
    var edge = edgeOf(el, e);
    setNow(el, POS[edge], emptySize(edge));
    el.style.backgroundSize = '100% 100%';
    el.classList.add('is-on');
  }

  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function release(el) {
    el.style.transition = 'none';
    el.style.backgroundPosition = '';
    el.style.backgroundSize = '';
    void el.offsetWidth;
    el.style.transition = '';
  }

  function leave(el, e) {
    var edge = edgeOf(el, e);
    setNow(el, POS[edge], '100% 100%');
    el.style.backgroundSize = emptySize(edge);
    el.classList.remove('is-on');
    if (reduce.matches) release(el);
  }

  function goldOf(t) { return t && t.closest ? t.closest('.tly-goldfill') : null; }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var el = goldOf(e.target);
    if (el && !el.contains(e.relatedTarget)) enter(el, e);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'touch') return;
    var el = goldOf(e.target);
    if (el && !el.contains(e.relatedTarget)) leave(el, e);
  });
  // once drained, hand control back to the stylesheet (so keyboard focus can fill again)
  document.addEventListener('transitionend', function (e) {
    var el = e.target;
    if (e.propertyName !== 'background-size' || !el.classList || !el.classList.contains('tly-goldfill') || el.classList.contains('is-on')) return;
    release(el);
  });
})();

/* HOVER-1027 (Claude, 2026-10-27, Steven's hover brief). Two additions, same rules as above (mouse/pen only, touch ignored):
   1. Gift guide product cards (.tly-gg-tier, .tly-gg-tile, written in the article text) get the standard gold loop markup
      (<span class="t3-cbox"><span class="t3-cf">) and class tly-trace; the look is in assets/tly-card-style.css (HOVER-1027).
   2. Direction-aware fill for the gift guide pills (.tly-gg-pill) and info boxes (.tly-gg-feature): data-tly-e = the edge the pointer
      came in by (the fill grows from it) and, on leave, the edge it left by (the fill shrinks toward it); class is-in = filled. */
(function () {
  if (window.tlyHover1027) return;
  window.tlyHover1027 = true;
  var CARDS = '.tly-gg-tier, .tly-gg-tile', FILL = '.tly-gg-pill, .tly-gg-feature';

  function addLoops(root) {
    var list = (root || document).querySelectorAll(CARDS);
    for (var i = 0; i < list.length; i++) {
      var c = list[i];
      if (c.querySelector(':scope > .t3-cbox')) continue;
      var box = document.createElement('span'), f = document.createElement('span');
      box.className = 't3-cbox'; box.setAttribute('aria-hidden', 'true'); f.className = 't3-cf';
      box.appendChild(f); c.insertBefore(box, c.firstChild); c.classList.add('tly-trace');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { addLoops(); });
  else addLoops();

  function edgeOf(el, e) {
    var r = el.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
    if (x < 0) return 'left';
    if (x > r.width) return 'right';
    if (y < 0) return 'top';
    if (y > r.height) return 'bottom';
    var d = { left: x / r.width, right: (r.width - x) / r.width, top: y / r.height, bottom: (r.height - y) / r.height }, best = 'left';
    for (var k in d) if (d[k] < d[best]) best = k;
    return best;
  }
  function snapEdge(el, edge) {
    el.classList.add('tly-df-snap');
    el.setAttribute('data-tly-e', edge);
    void el.offsetWidth;
    el.classList.remove('tly-df-snap');
  }
  function fillOf(t) { return t && t.closest ? t.closest(FILL) : null; }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var el = fillOf(e.target);
    if (!el || el.contains(e.relatedTarget)) return;
    el.classList.remove('is-in'); snapEdge(el, edgeOf(el, e)); el.classList.add('is-in');
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'touch') return;
    var el = fillOf(e.target);
    if (!el || el.contains(e.relatedTarget)) return;
    snapEdge(el, edgeOf(el, e)); el.classList.remove('is-in');
  });
})();

/* ==== STEADY-1027 (Steven 10-27): blog card photos. The CSS shows the top of each photo in a 2:1 box so the TEN LEI YEN logo printed along
   the bottom is cut off. Square product shots have no logo strip: they get class tly-sqimg and are shown whole. ==== */
(function () {
  if (window.tlySqImg) return; window.tlySqImg = true;
  var SEL = '.t3-bc .t3-bimg img,.t3-bl__pimg img,.t3-bl__fimg img,.tly-gold-card .article-card__media img,.tly-gold-card .card__media img,.tly-blog__media img';
  function mark(i) { var w = i.naturalWidth, h = i.naturalHeight; if (w && h) i.classList.toggle('tly-sqimg', w / h < 1.3); }
  function scan() {
    document.querySelectorAll(SEL).forEach(function (i) {
      if (i.complete) mark(i);
      i.addEventListener('load', function () { mark(i); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
/* ==== /STEADY-1027 ==== */

/* ==== REVIEWS-1027: review carousel cards link to <product>#reviews - scroll to the Judge.me review widget once it is drawn ==== */
(function () {
  if (location.hash !== '#reviews' || window.tlyRvScroll) return; window.tlyRvScroll = true;
  var n = 0, t = setInterval(function () {
    var w = document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget, [id*="judge_me_reviews_review_widget"]');
    if (w || ++n > 40) { clearInterval(t); if (w) w.scrollIntoView({ block: 'start' }); }
  }, 250);
})();
/* ==== /REVIEWS-1027 ==== */
